export const comments_3257606 = {"data":{"data":[],"links":{}}}